<template>
  <div class="row">
    <div class="col s0 m12 l12">
      <div class="row">
        <div class="col s0 m12 l12 global-result__item-label global-result__item-label--lo">
          No módulo {{ module.title }}
        </div>
      </div>

      <div
        class="row clickable"
        v-for="loResult in module.learningObjects"
        :key="'hsrlo_' + loResult.id"
        @click.prevent="click(loResult)"
      >
        <span class="col m12 l12 global-result__item-title">
          <span class="global-result__type-icon-wrap global-result__type-icon-wrap--lo">
            <i class="material-icons global-result__type-icon">{{ loIcon(loResult) }}</i>
          </span>
          {{ loResult.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalSearchResultLearningObjects",
  emits: ["click"],
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  methods: {
    click(learningObject) {
      this.$emit("click", { learningObjectId: learningObject.id });
    },
    loIcon(lo) {
      if (lo.broadcast) return "play_circle_outline";
      if (lo.audio) return "headphones";
      if (lo.pdf) return "picture_as_pdf";
      if (lo.htmlContent) return "code";
      if (lo.forms) {
        if (lo.forms.type === "SurveyResearch") return "help_outline";
        if (lo.forms.type === "Proof" || lo.forms.type === "Simulated") return "assignment";
        return "edit";
      }
      if (lo.externalContent) return lo.externalContent.icon || "open_in_new";
      return "play_circle_outline";
    },
  },
};
</script>
